import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {ShipmentOdsApiService} from './shipmentods-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    ShipmentOdsApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkShipmentOdsModule { }
